function formatSMS(phone: string): string {
  const last4Digits = phone.trim().slice(-4)
  return `•••-•••-${last4Digits}`
}

export default formatSMS
